var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTourSvg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 358,
    height: 272,
    viewBox: "0 0 358 272",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_108",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 11,
    width: 253,
    height: 253
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M267.971 226.188C317.157 177.003 317.157 97.2572 267.971 48.0717C218.786 -1.11373 139.04 -1.11375 89.855 48.0717C40.6696 97.2572 40.6696 177.003 89.855 226.188C139.04 275.373 218.786 275.373 267.971 226.188Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1878 216.364L51.9097 218.645L60.6462 227.37L62.9243 225.088L54.1878 216.364Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9043 225.108L54.1855 227.386L62.9099 218.65L60.6286 216.372L51.9043 225.108Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.218 239.446L51.9399 241.727L60.6765 250.451L62.9546 248.17L54.218 239.446Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9223 248.177L54.2036 250.455L62.928 241.719L60.6467 239.441L51.9223 248.177Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2298 260.905L51.9517 263.186L60.6882 271.911L62.9663 269.629L54.2298 260.905Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9477 269.672L54.229 271.95L62.9534 263.213L60.6721 260.935L51.9477 269.672Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1555 148.011L51.8774 150.292L60.614 159.017L62.8921 156.735L54.1555 148.011Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8554 156.728L54.1367 159.006L62.8611 150.27L60.5798 147.992L51.8554 156.728Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.156 171.08L51.8779 173.362L60.6145 182.086L62.8926 179.805L54.156 171.08Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8794 179.827L54.1606 182.105L62.885 173.369L60.6037 171.091L51.8794 179.827Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.179 192.544L51.9009 194.826L60.6374 203.55L62.9155 201.269L54.179 192.544Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8911 201.291L54.1724 203.569L62.8967 194.833L60.6154 192.554L51.8911 201.291Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1072 79.6151L51.8291 81.8964L60.5656 90.6207L62.8437 88.3394L54.1072 79.6151Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8183 88.365L54.0996 90.6431L62.824 81.9066L60.5427 79.6285L51.8183 88.365Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1072 102.727L51.8291 105.008L60.5657 113.732L62.8437 111.451L54.1072 102.727Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8486 111.446L54.1299 113.725L62.8542 104.988L60.573 102.71L51.8486 111.446Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.1301 124.191L51.8521 126.473L60.5886 135.197L62.8667 132.916L54.1301 124.191Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8613 132.91L54.1426 135.188L62.8669 126.452L60.5856 124.174L51.8613 132.91Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0462 11.2669L51.7681 13.5482L60.5046 22.2725L62.7827 19.9912L54.0462 11.2669Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7763 19.9965L54.0576 22.2746L62.782 13.5381L60.5007 11.26L51.7763 19.9965Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0769 34.3306L51.7988 36.6118L60.5354 45.3362L62.8135 43.0549L54.0769 34.3306Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7939 43.0654L54.0752 45.3435L62.7996 36.6069L60.5183 34.3288L51.7939 43.0654Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0823 55.795L51.8042 58.0763L60.5407 66.8007L62.8188 64.5194L54.0823 55.795Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8076 64.5471L54.0889 66.8252L62.8132 58.0887L60.5319 55.8106L51.8076 64.5471Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4617 216.363L76.1836 218.644L84.9201 227.368L87.1982 225.087L78.4617 216.363Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1704 225.085L78.4517 227.363L87.176 218.627L84.8947 216.349L76.1704 225.085Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.421 216.339L99.1431 218.62L107.88 227.344L110.158 225.063L101.421 216.339Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1401 225.066L101.421 227.344L110.146 218.608L107.864 216.33L99.1401 225.066Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.349 216.32L122.071 218.601L130.808 227.326L133.086 225.045L124.349 216.32Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.097 225.06L124.378 227.338L133.102 218.602L130.821 216.324L122.097 225.06Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.307 216.325L145.029 218.606L153.765 227.33L156.043 225.049L147.307 216.325Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.004 225.041L147.286 227.319L156.01 218.583L153.729 216.305L145.004 225.041Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.236 216.288L167.958 218.569L176.695 227.294L178.973 225.012L170.236 216.288Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.962 225.035L170.243 227.313L178.968 218.576L176.686 216.298L167.962 225.035Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4934 239.409L76.2153 241.69L84.9519 250.414L87.23 248.133L78.4934 239.409Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1889 248.172L78.4702 250.45L87.1946 241.713L84.9133 239.435L76.1889 248.172Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.421 239.408L99.1431 241.689L107.88 250.413L110.158 248.132L101.421 239.408Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1269 248.165L101.408 250.444L110.133 241.707L107.851 239.429L99.1269 248.165Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.38 239.419L122.102 241.701L130.838 250.425L133.116 248.144L124.38 239.419Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.097 248.146L124.378 250.425L133.102 241.688L130.821 239.41L122.097 248.146Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.321 239.388L145.042 241.67L153.779 250.394L156.057 248.113L147.321 239.388Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.023 248.11L147.304 250.388L156.029 241.652L153.747 239.374L145.023 248.11Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.267 239.387L167.989 241.669L176.726 250.393L179.004 248.112L170.267 239.387Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.962 248.104L170.243 250.382L178.968 241.645L176.686 239.367L167.962 248.104Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4988 260.891L76.2207 263.172L84.9573 271.897L87.2353 269.615L78.4988 260.891Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2192 269.636L78.5005 271.914L87.2248 263.177L84.9436 260.899L76.2192 269.636Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.445 260.89L99.1665 263.171L107.903 271.896L110.181 269.614L101.445 260.89Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1401 269.63L101.421 271.908L110.146 263.171L107.864 260.893L99.1401 269.63Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.386 260.884L122.107 263.165L130.844 271.89L133.122 269.608L124.386 260.884Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.11 269.611L124.391 271.889L133.115 263.152L130.834 260.874L122.11 269.611Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.331 260.865L145.053 263.147L153.79 271.871L156.068 269.59L147.331 260.865Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.048 269.604L147.329 271.883L156.053 263.146L153.772 260.868L145.048 269.604Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.273 260.852L167.995 263.133L176.731 271.858L179.009 269.576L170.273 260.852Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.974 269.568L170.255 271.846L178.98 263.109L176.698 260.831L167.974 269.568Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4133 147.991L76.1353 150.272L84.8718 158.997L87.1499 156.715L78.4133 147.991Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1411 156.722L78.4224 159L87.1467 150.263L84.8654 147.985L76.1411 156.722Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.372 147.96L99.0942 150.241L107.831 158.965L110.109 156.684L101.372 147.96Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0844 156.702L101.366 158.98L110.09 150.244L107.809 147.966L99.0844 156.702Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.318 147.959L122.04 150.24L130.776 158.965L133.054 156.683L124.318 147.959Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.022 156.696L124.304 158.975L133.028 150.238L130.747 147.96L122.022 156.696Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.247 147.923L144.969 150.204L153.705 158.928L155.983 156.647L147.247 147.923Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.98 156.672L147.262 158.95L155.986 150.214L153.705 147.936L144.98 156.672Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.193 147.922L167.915 150.203L176.651 158.927L178.929 156.646L170.193 147.922Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.919 156.666L170.201 158.944L178.925 150.208L176.644 147.93L167.919 156.666Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4436 171.073L76.1655 173.354L84.9021 182.078L87.1802 179.797L78.4436 171.073Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1582 179.79L78.4395 182.069L87.1638 173.332L84.8825 171.054L76.1582 179.79Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.385 171.041L99.1069 173.323L107.843 182.047L110.122 179.766L101.385 171.041Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.102 179.771L101.383 182.05L110.108 173.313L107.826 171.035L99.102 179.771Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.331 171.023L122.053 173.304L130.789 182.029L133.067 179.747L124.331 171.023Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.041 179.765L124.322 182.043L133.047 173.307L130.765 171.029L122.041 179.765Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.277 171.022L144.999 173.303L153.736 182.028L156.014 179.746L147.277 171.022Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.98 179.759L147.262 182.037L155.986 173.3L153.705 171.022L144.98 179.759Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.205 171.003L167.927 173.285L176.663 182.009L178.941 179.728L170.205 171.003Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.937 179.752L170.218 182.03L178.943 173.294L176.661 171.016L167.937 179.752Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4485 192.554L76.1704 194.836L84.907 203.56L87.1851 201.279L78.4485 192.554Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1699 201.254L78.4512 203.532L87.1755 194.796L84.8943 192.518L76.1699 201.254Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.395 192.518L99.1167 194.8L107.853 203.524L110.131 201.243L101.395 192.518Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1269 201.248L101.408 203.526L110.133 194.79L107.851 192.512L99.1269 201.248Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.353 192.505L122.075 194.786L130.811 203.51L133.089 201.229L124.353 192.505Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.053 201.229L124.334 203.507L133.058 194.771L130.777 192.493L122.053 201.229Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.282 192.487L145.004 194.768L153.74 203.492L156.019 201.211L147.282 192.487Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.992 201.223L147.273 203.501L155.998 194.765L153.717 192.487L144.992 201.223Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.228 192.468L167.95 194.749L176.687 203.474L178.965 201.192L170.228 192.468Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.949 201.217L170.23 203.495L178.954 194.758L176.673 192.48L167.949 201.217Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3821 79.6127L76.104 81.894L84.8406 90.6183L87.1186 88.337L78.3821 79.6127Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.103 88.3406L78.3843 90.6187L87.1086 81.8821L84.8274 79.604L76.103 88.3406Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.311 79.6119L99.0332 81.8931L107.77 90.6175L110.048 88.3362L101.311 79.6119Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0239 88.3346L101.305 90.6127L110.03 81.8761L107.748 79.598L99.0239 88.3346Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.257 79.5931L121.979 81.8744L130.716 90.5988L132.994 88.3175L124.257 79.5931Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.981 88.3279L124.263 90.606L132.987 81.8695L130.706 79.5914L121.981 88.3279Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.198 79.5621L144.919 81.8434L153.656 90.5678L155.934 88.2865L147.198 79.5621Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.907 88.3095L147.188 90.5876L155.912 81.851L153.631 79.5729L144.907 88.3095Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.157 79.5559L167.878 81.8372L176.615 90.5615L178.893 88.2803L170.157 79.5559Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.858 88.2903L170.139 90.5684L178.864 81.8318L176.582 79.5538L167.858 88.2903Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3953 102.694L76.1172 104.976L84.8537 113.7L87.1318 111.419L78.3953 102.694Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.103 111.427L78.3843 113.705L87.1086 104.969L84.8274 102.691L76.103 111.427Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.341 102.676L99.0625 104.957L107.799 113.681L110.077 111.4L101.341 102.676Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0595 111.421L101.341 113.699L110.065 104.962L107.784 102.684L99.0595 111.421Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.269 102.675L121.991 104.956L130.728 113.68L133.006 111.399L124.269 102.675Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.98 111.415L124.262 113.693L132.986 104.956L130.705 102.678L121.98 111.415Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.228 102.626L144.95 104.907L153.687 113.631L155.965 111.35L147.228 102.626Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.925 111.378L147.206 113.656L155.93 104.919L153.649 102.641L144.925 111.378Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.157 102.607L167.878 104.889L176.615 113.613L178.893 111.332L170.157 102.607Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.882 111.372L170.164 113.65L178.888 104.913L176.607 102.635L167.882 111.372Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4055 124.171L76.1274 126.452L84.864 135.176L87.1421 132.895L78.4055 124.171Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1279 132.903L78.4092 135.181L87.1335 126.445L84.8523 124.167L76.1279 132.903Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.346 124.14L99.0684 126.421L107.805 135.146L110.083 132.864L101.346 124.14Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0542 132.885L101.335 135.163L110.06 126.426L107.779 124.148L99.0542 132.885Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.293 124.121L122.015 126.403L130.751 135.127L133.029 132.846L124.293 124.121Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.994 132.879L124.275 135.157L132.999 126.42L130.718 124.142L121.994 132.879Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.221 124.103L144.943 126.384L153.68 135.108L155.958 132.827L147.221 124.103Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.968 132.854L147.25 135.133L155.974 126.396L153.693 124.118L144.968 132.854Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.179 124.089L167.901 126.371L176.638 135.095L178.916 132.814L170.179 124.089Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.894 132.835L170.175 135.114L178.9 126.377L176.618 124.099L167.894 132.835Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3206 11.247L76.0425 13.5283L84.779 22.2526L87.0571 19.9713L78.3206 11.247Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0425 19.9904L78.3237 22.2685L87.0481 13.532L84.7668 11.2539L76.0425 19.9904Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.262 11.2157L98.9839 13.497L107.72 22.2213L109.999 19.9401L101.262 11.2157Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9868 19.9713L101.268 22.2494L109.992 13.5128L107.711 11.2347L98.9868 19.9713Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.221 11.2097L121.943 13.491L130.679 22.2153L132.958 19.934L124.221 11.2097Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.938 19.9523L124.219 22.2304L132.944 13.4938L130.662 11.2157L121.938 19.9523Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.166 11.2089L144.888 13.4902L153.625 22.2145L155.903 19.9333L147.166 11.2089Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.895 19.9286L147.176 22.2067L155.9 13.4701L153.619 11.1921L144.895 19.9286Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.095 11.1902L167.817 13.4715L176.553 22.1958L178.832 19.9145L170.095 11.1902Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.834 19.922L170.115 22.2001L178.84 13.4635L176.558 11.1854L167.834 19.922Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3338 34.3106L76.0557 36.5919L84.7922 45.3162L87.0703 43.0349L78.3338 34.3106Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0605 43.0588L78.3418 45.3369L87.0662 36.6004L84.7849 34.3223L76.0605 43.0588Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.28 34.3098L99.002 36.5911L107.738 45.3155L110.017 43.0342L101.28 34.3098Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.018 43.0529L101.299 45.331L110.024 36.5944L107.742 34.3163L99.018 43.0529Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.238 34.2788L121.96 36.5601L130.697 45.2844L132.975 43.0032L124.238 34.2788Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.943 43.0339L124.224 45.312L132.948 36.5755L130.667 34.2974L121.943 43.0339Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.179 34.2726L144.901 36.5538L153.637 45.2782L155.916 42.9969L147.179 34.2726Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.895 43.0147L147.176 45.2928L155.9 36.5563L153.619 34.2782L144.895 43.0147Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.125 34.2718L167.847 36.5531L176.584 45.2774L178.862 42.9961L170.125 34.2718Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.852 43.0088L170.133 45.2869L178.858 36.5503L176.576 34.2722L167.852 43.0088Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3572 55.793L76.0791 58.0743L84.8156 66.7986L87.0937 64.5173L78.3572 55.793Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0727 64.5231L78.354 66.8011L87.0784 58.0646L84.7971 55.7865L76.0727 64.5231Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.303 55.7739L99.0254 58.0551L107.762 66.7795L110.04 64.4982L101.303 55.7739Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0298 64.5165L101.311 66.7946L110.035 58.058L107.754 55.7799L99.0298 64.5165Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.231 55.7552L121.953 58.0365L130.69 66.7609L132.968 64.4796L124.231 55.7552Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.968 64.5099L124.25 66.788L132.974 58.0515L130.693 55.7734L121.968 64.5099Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.19 55.7418L144.912 58.0231L153.648 66.7475L155.926 64.4662L147.19 55.7418Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.894 64.4909L147.176 66.769L155.9 58.0325L153.619 55.7544L144.894 64.4909Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.131 55.7359L167.853 58.0172L176.589 66.7416L178.867 64.4603L170.131 55.7359Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.864 64.4548L170.146 66.7328L178.87 57.9963L176.589 55.7182L167.864 64.4548Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.907 216.279L188.628 218.561L197.365 227.285L199.643 225.004L190.907 216.279Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.624 225.018L190.906 227.297L199.63 218.56L197.349 216.282L188.624 225.018Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.853 216.261L211.575 218.542L220.311 227.266L222.589 224.985L213.853 216.261Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.582 225.012L213.863 227.29L222.588 218.554L220.306 216.276L211.582 225.012Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.824 216.26L234.546 218.541L243.282 227.265L245.561 224.984L236.824 216.26Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.52 224.981L236.802 227.259L245.526 218.522L243.245 216.244L234.52 224.981Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.752 216.241L257.474 218.523L266.21 227.247L268.488 224.966L259.752 216.241Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.458 224.974L259.74 227.252L268.464 218.516L266.183 216.238L257.458 224.974Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.698 216.205L280.42 218.486L289.156 227.211L291.435 224.929L282.698 216.205Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.434 224.968L282.715 227.246L291.44 218.509L289.158 216.231L280.434 224.968Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.937 239.361L188.659 241.642L197.396 250.367L199.674 248.085L190.937 239.361Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.643 248.105L190.924 250.383L199.649 241.646L197.367 239.368L188.643 248.105Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.865 239.342L211.586 241.624L220.323 250.348L222.601 248.067L213.865 239.342Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.581 248.099L213.862 250.377L222.587 241.64L220.305 239.362L211.581 248.099Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.824 239.311L234.546 241.592L243.282 250.317L245.561 248.035L236.824 239.311Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.525 248.062L236.807 250.34L245.531 241.603L243.25 239.325L234.525 248.062Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.782 239.305L257.503 241.586L266.24 250.311L268.518 248.029L259.782 239.305Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.494 248.043L259.775 250.321L268.5 241.584L266.218 239.306L257.494 248.043Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.71 239.304L280.432 241.586L289.169 250.31L291.447 248.029L282.71 239.304Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.434 248.037L282.715 250.315L291.439 241.578L289.158 239.3L280.434 248.037Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.942 260.843L188.664 263.124L197.401 271.849L199.679 269.567L190.942 260.843Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.655 269.569L190.936 271.847L199.66 263.11L197.379 260.832L188.655 269.569Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.888 260.807L211.61 263.088L220.347 271.812L222.625 269.531L213.888 260.807Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.594 269.562L213.875 271.84L222.6 263.104L220.319 260.826L211.594 269.562Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.834 260.77L234.556 263.052L243.293 271.776L245.571 269.495L236.834 260.77Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.569 269.539L236.85 271.817L245.574 263.08L243.293 260.802L234.569 269.539Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.774 260.757L257.496 263.039L266.233 271.763L268.511 269.482L259.774 260.757Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.494 269.52L259.775 271.798L268.5 263.061L266.218 260.783L257.494 269.52Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.734 260.769L280.456 263.05L289.192 271.774L291.47 269.493L282.734 260.769Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.428 269.501L282.709 271.779L291.434 263.043L289.153 260.764L280.428 269.501Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.875 147.883L188.597 150.165L197.333 158.889L199.611 156.608L190.875 147.883Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.587 156.655L190.868 158.934L199.593 150.197L197.311 147.919L188.587 156.655Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.816 147.895L211.538 150.176L220.274 158.901L222.552 156.619L213.816 147.895Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.539 156.619L213.82 158.897L222.545 150.16L220.263 147.882L211.539 156.619Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.762 147.876L234.484 150.158L243.221 158.882L245.499 156.601L236.762 147.876Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.46 156.63L236.741 158.908L245.466 150.172L243.184 147.894L234.46 156.63Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.69 147.858L257.412 150.139L266.149 158.863L268.427 156.582L259.69 147.858Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.416 156.606L259.697 158.884L268.422 150.148L266.14 147.87L257.416 156.606Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.65 147.844L280.372 150.126L289.108 158.85L291.386 156.569L282.65 147.844Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.361 156.587L282.642 158.865L291.366 150.129L289.085 147.851L280.361 156.587Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.875 170.978L188.597 173.259L197.333 181.983L199.611 179.702L190.875 170.978Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.6 179.737L190.881 182.015L199.606 173.278L197.324 171L188.6 179.737Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.833 170.964L211.555 173.245L220.292 181.97L222.57 179.688L213.833 170.964Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.543 179.718L213.825 181.996L222.549 173.259L220.268 170.981L211.543 179.718Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.774 170.958L234.496 173.239L243.233 181.964L245.511 179.682L236.774 170.958Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.495 179.699L236.776 181.977L245.5 173.24L243.219 170.962L234.495 179.699Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.72 170.94L257.442 173.221L266.179 181.945L268.457 179.664L259.72 170.94Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.434 179.693L259.715 181.971L268.44 173.235L266.158 170.956L257.434 179.693Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.662 170.908L280.384 173.19L289.12 181.914L291.398 179.633L282.662 170.908Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.378 179.656L282.66 181.934L291.384 173.198L289.103 170.92L280.378 179.656Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.898 192.46L188.62 194.741L197.357 203.465L199.635 201.184L190.898 192.46Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.595 201.201L190.876 203.479L199.6 194.742L197.319 192.464L188.595 201.201Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.839 192.429L211.561 194.71L220.298 203.434L222.576 201.153L213.839 192.429Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.538 201.182L213.819 203.46L222.544 194.723L220.262 192.445L211.538 201.182Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.799 192.423L234.521 194.704L243.257 203.428L245.535 201.147L236.799 192.423Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.508 201.163L236.789 203.441L245.513 194.705L243.232 192.427L234.508 201.163Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.726 192.404L257.448 194.685L266.184 203.41L268.462 201.128L259.726 192.404Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.447 201.157L259.728 203.435L268.452 194.699L266.171 192.42L257.447 201.157Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.673 192.385L280.395 194.667L289.131 203.391L291.409 201.11L282.673 192.385Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.403 201.133L282.685 203.411L291.409 194.674L289.128 192.396L280.403 201.133Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.827 79.548L188.549 81.8293L197.285 90.5536L199.563 88.2724L190.827 79.548Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.54 88.2746L190.821 90.5527L199.546 81.8161L197.264 79.5381L188.54 88.2746Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.755 79.5116L211.477 81.7929L220.214 90.5173L222.492 88.236L213.755 79.5116Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.479 88.2685L213.76 90.5466L222.485 81.8101L220.203 79.532L211.479 88.2685Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.714 79.4983L234.436 81.7795L243.173 90.5039L245.451 88.2226L236.714 79.4983Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.441 88.2495L236.722 90.5276L245.447 81.7911L243.165 79.513L234.441 88.2495Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.659 79.4796L257.381 81.7609L266.118 90.4853L268.396 88.204L259.659 79.4796Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.379 88.243L259.661 90.5211L268.385 81.7845L266.104 79.5064L257.379 88.243Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.605 79.4789L280.327 81.7602L289.064 90.4845L291.342 88.2032L282.605 79.4789Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.3 88.237L282.581 90.5151L291.305 81.7786L289.024 79.5005L280.3 88.237Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.84 102.612L188.562 104.893L197.298 113.617L199.576 111.336L190.84 102.612Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.558 111.361L190.839 113.639L199.563 104.903L197.282 102.625L188.558 111.361Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.785 102.593L211.507 104.874L220.244 113.599L222.522 111.317L213.785 102.593Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.515 111.337L213.796 113.615L222.52 104.879L220.239 102.6L211.515 111.337Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.731 102.592L234.453 104.874L243.19 113.598L245.468 111.317L236.731 102.592Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.436 111.331L236.717 113.609L245.441 104.873L243.16 102.595L234.436 111.331Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.673 102.561L257.395 104.842L266.131 113.567L268.409 111.285L259.673 102.561Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.379 111.312L259.661 113.59L268.385 104.854L266.104 102.575L257.379 111.312Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.619 102.542L280.341 104.824L289.077 113.548L291.355 111.267L282.619 102.542Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.336 111.305L282.617 113.584L291.342 104.847L289.06 102.569L280.336 111.305Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.863 124.076L188.584 126.358L197.321 135.082L199.599 132.801L190.863 124.076Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.588 132.808L190.87 135.086L199.594 126.349L197.313 124.071L188.588 132.808Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.808 124.075L211.53 126.357L220.267 135.081L222.545 132.8L213.808 124.075Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.527 132.801L213.808 135.079L222.532 126.343L220.251 124.065L211.527 132.801Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.737 124.074L234.458 126.356L243.195 135.08L245.473 132.799L236.737 124.074Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.448 132.813L236.729 135.091L245.453 126.354L243.172 124.076L234.448 132.813Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.696 124.026L257.417 126.307L266.154 135.031L268.432 132.75L259.696 124.026Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.392 132.776L259.673 135.054L268.398 126.318L266.116 124.04L257.392 132.776Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.625 124.025L280.347 126.306L289.083 135.03L291.361 132.749L282.625 124.025Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.35 132.77L282.631 135.048L291.355 126.311L289.074 124.033L280.35 132.77Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.783 11.1819L188.505 13.4632L197.242 22.1875L199.52 19.9063L190.783 11.1819Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.497 19.9237L190.778 22.2017L199.503 13.4652L197.221 11.1871L188.497 19.9237Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.724 11.1509L211.446 13.4322L220.183 22.1565L222.461 19.8752L213.724 11.1509Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.441 19.8874L213.723 22.1655L222.447 13.429L220.166 11.1509L211.441 19.8874Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.652 11.1323L234.374 13.4135L243.111 22.1379L245.389 19.8566L236.652 11.1323Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.38 19.8809L236.661 22.159L245.385 13.4224L243.104 11.1444L234.38 19.8809Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.598 11.1136L257.32 13.3949L266.057 22.1193L268.335 19.838L259.598 11.1136Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.337 19.8748L259.618 22.1529L268.343 13.4164L266.061 11.1383L257.337 19.8748Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.57 11.1127L280.292 13.394L289.028 22.1184L291.306 19.8371L282.57 11.1127Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.293 19.8255L282.575 22.1036L291.299 13.3671L289.018 11.089L280.293 19.8255Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.796 34.2458L188.518 36.5271L197.255 45.2514L199.533 42.9701L190.796 34.2458Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.515 42.9927L190.796 45.2708L199.521 36.5342L197.239 34.2561L188.515 42.9927Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.755 34.2324L211.477 36.5137L220.213 45.238L222.491 42.9568L213.755 34.2324Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.441 42.9737L213.723 45.2518L222.447 36.5153L220.166 34.2372L211.441 42.9737Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.665 34.1961L234.387 36.4773L243.124 45.2017L245.402 42.9204L236.665 34.1961Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.399 42.9676L236.68 45.2457L245.405 36.5092L243.123 34.2311L234.399 42.9676Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.612 34.1952L257.333 36.4765L266.07 45.2008L268.348 42.9196L259.612 34.1952Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.355 42.9434L259.637 45.2215L268.361 36.485L266.08 34.2069L257.355 42.9434Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.557 34.1944L280.279 36.4756L289.015 45.2L291.293 42.9187L282.557 34.1944Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.276 42.9551L282.557 45.2332L291.281 36.4967L289 34.2186L280.276 42.9551Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.802 55.7098L188.523 57.9911L197.26 66.7154L199.538 64.4342L190.802 55.7098Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.528 64.4563L190.81 66.7344L199.534 57.9979L197.253 55.7198L188.528 64.4563Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.748 55.7091L211.47 57.9903L220.206 66.7147L222.484 64.4334L213.748 55.7091Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.467 64.4499L213.748 66.728L222.472 57.9915L220.191 55.7134L211.467 64.4499Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.689 55.6601L234.411 57.9414L243.147 66.6658L245.425 64.3845L236.689 55.6601Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.429 64.4135L236.71 66.6917L245.435 57.9551L243.154 55.677L234.429 64.4135Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.635 55.6598L257.357 57.9411L266.093 66.6654L268.372 64.3841L259.635 55.6598Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.35 64.4076L259.631 66.6857L268.355 57.9491L266.074 55.671L257.35 64.4076Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.581 55.6588L280.303 57.94L289.039 66.6644L291.317 64.3831L282.581 55.6588Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.289 64.4191L282.57 66.6972L291.294 57.9607L289.013 55.6826L280.289 64.4191Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.985 216.209L304.707 218.49L313.443 227.214L315.721 224.933L306.985 216.209Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.687 224.932L306.968 227.21L315.693 218.474L313.411 216.196L304.687 224.932Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.986 239.285L304.708 241.566L313.444 250.291L315.722 248.009L306.986 239.285Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.7 248.031L306.981 250.309L315.706 241.573L313.424 239.295L304.7 248.031Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.99 260.749L304.712 263.031L313.449 271.755L315.727 269.474L306.99 260.749Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.713 269.495L306.994 271.773L315.718 263.037L313.437 260.758L304.713 269.495Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.923 147.825L304.645 150.106L313.382 158.83L315.66 156.549L306.923 147.825Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.626 156.581L306.908 158.859L315.632 150.123L313.351 147.845L304.626 156.581Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.936 170.906L304.658 173.187L313.395 181.912L315.673 179.631L306.936 170.906Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.663 179.65L306.944 181.928L315.669 173.192L313.387 170.914L304.663 179.65Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.959 192.371L304.681 194.652L313.418 203.376L315.696 201.095L306.959 192.371Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.675 201.114L306.956 203.392L315.68 194.656L313.399 192.378L304.675 201.114Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.863 79.4586L304.585 81.7399L313.322 90.4643L315.6 88.183L306.863 79.4586Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.585 88.2125L306.867 90.4906L315.591 81.754L313.31 79.4759L304.585 88.2125Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.875 102.54L304.597 104.822L313.334 113.546L315.612 111.265L306.875 102.54Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.584 111.299L306.866 113.577L315.59 104.841L313.309 102.563L304.584 111.299Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.9 124.005L304.622 126.286L313.358 135.01L315.636 132.729L306.9 124.005Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.598 132.763L306.879 135.041L315.603 126.305L313.322 124.027L304.598 132.763Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.826 11.0931L304.548 13.3743L313.285 22.0987L315.563 19.8174L306.826 11.0931Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.542 19.8374L306.823 22.1155L315.548 13.3789L313.266 11.1008L304.542 19.8374Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.858 34.1746L304.58 36.4558L313.316 45.1802L315.594 42.8989L306.858 34.1746Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.56 42.9059L306.841 45.184L315.566 36.4475L313.284 34.1694L304.56 42.9059Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.863 55.639L304.585 57.9203L313.322 66.6447L315.6 64.3634L306.863 55.639Z",
    fill: "#A60A24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.572 64.37L306.854 66.6481L315.578 57.9115L313.297 55.6334L304.572 64.37Z",
    fill: "#A60A24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTourSvg1);
export default __webpack_public_path__ + "static/media/tour_svg_1.b7ab0c91d2cb74581ac1207485b5f2dc.svg";
export { ForwardRef as ReactComponent };